var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10255_33392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.99854C6.5 2.39636 6.65804 2.77789 6.93934 3.0592C7.22064 3.3405 7.60218 3.49854 8 3.49854C8.39782 3.49854 8.77936 3.3405 9.06066 3.0592C9.34196 2.77789 9.5 2.39636 9.5 1.99854C9.5 1.60071 9.34196 1.21918 9.06066 0.937875C8.77936 0.65657 8.39782 0.498535 8 0.498535C7.60218 0.498535 7.22064 0.65657 6.93934 0.937875C6.65804 1.21918 6.5 1.60071 6.5 1.99854V1.99854Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.9985C6.5 14.3964 6.65804 14.7779 6.93934 15.0592C7.22064 15.3405 7.60218 15.4985 8 15.4985C8.39782 15.4985 8.77936 15.3405 9.06066 15.0592C9.34196 14.7779 9.5 14.3964 9.5 13.9985C9.5 13.6007 9.34196 13.2192 9.06066 12.9379C8.77936 12.6566 8.39782 12.4985 8 12.4985C7.60218 12.4985 7.22064 12.6566 6.93934 12.9379C6.65804 13.2192 6.5 13.6007 6.5 13.9985Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13.9985C1 14.3964 1.15804 14.7779 1.43934 15.0592C1.72064 15.3405 2.10218 15.4985 2.5 15.4985C2.89782 15.4985 3.27936 15.3405 3.56066 15.0592C3.84196 14.7779 4 14.3964 4 13.9985C4 13.6007 3.84196 13.2192 3.56066 12.9379C3.27936 12.6566 2.89782 12.4985 2.5 12.4985C2.10218 12.4985 1.72064 12.6566 1.43934 12.9379C1.15804 13.2192 1 13.6007 1 13.9985V13.9985Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9985C12 14.3964 12.158 14.7779 12.4393 15.0592C12.7206 15.3405 13.1022 15.4985 13.5 15.4985C13.8978 15.4985 14.2794 15.3405 14.5607 15.0592C14.842 14.7779 15 14.3964 15 13.9985C15 13.6007 14.842 13.2192 14.5607 12.9379C14.2794 12.6566 13.8978 12.4985 13.5 12.4985C13.1022 12.4985 12.7206 12.6566 12.4393 12.9379C12.158 13.2192 12 13.6007 12 13.9985Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.4985C2.5 11.4377 2.92143 10.4203 3.67157 9.67011C4.42172 8.91996 5.43913 8.49854 6.5 8.49854H9.5C10.5609 8.49854 11.5783 8.91996 12.3284 9.67011C13.0786 10.4203 13.5 11.4377 13.5 12.4985",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.49854V12.4985",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10255_33392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesIcon);
export default __webpack_public_path__ + "static/media/Modules_icon.1b252fec.svg";
export { ForwardRef as ReactComponent };